import { LastViewedObject } from "../../types/types";
import useFetchPage from "../hooks/useFetchPage";
import List from "../List";
import Page from "../Page";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Documents = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        <List isDocuments={true} />
      </Page>
    )
  );
};

export default Documents;
